import i18n from '@/i18n/i18n'
import SubCategoryService from '@/services/admin/SubCategoryService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  subCategories: null,
  subCategory: {},
  products: null
}

export const mutations = {
  SET_SUB_CATEGORIES(state, subCategories) {
    state.subCategories = subCategories.data
  },
  SET_SUB_CATEGORY(state, subCategory) {
    state.subCategory = subCategory
  },
  ADD_SUB_CATEGORY(state, subCategory) {
    state.subCategories.push(subCategory)
  },
  SET_PRODUCTS(state, products) {
    state.products = products
  }
}

export const getters = {
  getSubCategoryById: state => id => {
    return state.subCategories ? state.subCategories.find(subCategory => subCategory.id === id) : false
  }
}

export const actions = {
  getSubCategories({ commit, dispatch, state }, categoryId) {
    if (state.subCategories && state.subCategories[0].category_id == categoryId) return state.subCategories

    return new Promise((resolve, reject) => {
      SubCategoryService.getSubCategories(categoryId)
        .then(response => {
          commit('SET_SUB_CATEGORIES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.sub_category.sub_categories')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getAllSubCategories({ commit, dispatch }) {
    return new Promise((resolve, reject) =>
      SubCategoryService.getAllSubCategories()
        .then(response => {
          commit('SET_SUB_CATEGORIES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.sub_category.sub_categories')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    )
  },
  getSubCategory({ commit, dispatch, state, getters }, params) {
    if (params.id == state.subCategory.id) return state.subCategory

    let subCategory = getters.getSubCategoryById(params.id)

    if (subCategory) {
      commit('SET_SUB_CATEGORY', subCategory)
      return subCategory
    } else {
      return new Promise((resolve, reject) => {
        SubCategoryService.getSubCategory(params.categoryId, params.id)
          .then(response => {
            commit('SET_SUB_CATEGORY', response.data)
            resolve(response)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message:
                t('store.shared.fetching_problem', {
                  element: t('store.admin.sub_category.sub_category')
                }) + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
      })
    }
  },
  editSubCategory({ dispatch, commit }, subCategory) {
    return new Promise((resolve, reject) => {
      SubCategoryService.editSubCategory(subCategory.category_id, subCategory.id, subCategory)
        .then(response => {
          commit('SET_SUB_CATEGORY', subCategory)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.sub_category.sub_category')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.sub_category.sub_categories')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSubCategory({ dispatch, state, commit }, params) {
    return new Promise((resolve, reject) => {
      SubCategoryService.createSubCategory(params.categoryId, params.subCategory)
        .then(response => {
          if (state.subCategories) {
            commit('ADD_SUB_CATEGORY', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('store.admin.sub_category.sub_category')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.sub_category.sub_category')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getProducts({ commit, dispatch, state }, id) {
    if (state.products && state.products[0].id == id) return state.products

    return new Promise((resolve, reject) => {
      SubCategoryService.getProducts(id)
        .then(response => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.sub_category.products')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
